import { Layer, Source } from '@vis.gl/react-maplibre';

import TrafficInfoBoardIcon from '@/assets/icons/map/traffic-report/traffic-info-board.svg?url';
import { useMapImages } from '@/hooks/useMapImages';
import { GeoServer } from '@/modules/GeoServer';

export const TRAFFIC_INFO_BOARD_LAYER = 'TRAFFIC_INFO_BOARD_LAYER';
const TRAFFIC_INFO_BOARD_ICON = 'TRAFFIC_INFO_BOARD_ICON';

export function TrafficInfoBoardLayer() {
  useMapImages({
    images: [{ name: TRAFFIC_INFO_BOARD_ICON, url: TrafficInfoBoardIcon, width: 36, height: 36 }],
  });

  return (
    <Source
      key={TRAFFIC_INFO_BOARD_LAYER}
      data={GeoServer.wfs({ typeName: 'signs_view' })}
      filter={['to-boolean', ['get', 'content']]}
      id={TRAFFIC_INFO_BOARD_LAYER}
      type="geojson"
    >
      <Layer
        id={TRAFFIC_INFO_BOARD_LAYER}
        type="symbol"
        layout={{
          'icon-allow-overlap': true,
          'icon-image': TRAFFIC_INFO_BOARD_ICON,
        }}
      />
    </Source>
  );
}
